import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { MEETING_LIST_PAGE_TOKEN } from '../data-providers/providers';

@Component({
  selector: 'meeting-scheduler-calendar-page',
  templateUrl: './calendar-page.component.html',
  styleUrls: ['./calendar-page.component.scss'],
  standalone: false,
})
export class CalendarPageComponent implements OnInit {
  calendarId: string;
  navigateAfterSave$: Observable<any[]>;

  constructor(
    @Inject(MEETING_LIST_PAGE_TOKEN) public readonly meetingListLink$: Observable<string>,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
    this.navigateAfterSave$ = meetingListLink$.pipe(map((link) => [link]));
  }

  ngOnInit(): void {
    this.calendarId = this.route.snapshot.params.calendarId || '';
    if (this.calendarId === '') {
      this.navigateToMeetingList();
    }
  }

  private async navigateToMeetingList(): Promise<unknown> {
    const meetingListLink = await this.meetingListLink$.pipe(take(1)).toPromise();
    return this.router.navigate([meetingListLink]);
  }
}
